exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".handing-table[data-v-f2e73fba]{margin-top:40px}.handing-pagination[data-v-f2e73fba]{margin-top:40px;height:40px;text-align:center}.a-preview[data-v-f2e73fba]{display:inline-block;width:150px;margin-right:20px}.a-preview img[data-v-f2e73fba]{width:100%;vertical-align:bottom}\n", ""]);

// exports
